import React from 'react';
import { FaFileExcel, FaFileWord, FaFilePdf, FaFileImage, FaFileCsv, FaFile, FaDownload } from 'react-icons/fa';
import '../styles/FileDownload.css';

const FileDownload = ({ url, filename }) => {
  // 파일 확장자 추출
  const getFileExtension = (url) => {
    const match = url.match(/\.([^./?#]+)(?:[?#]|$)/i);
    return match ? match[1].toLowerCase() : '';
  };

  // 파일 타입별 아이콘 반환
  const getFileIcon = (ext) => {
    switch (ext) {
      case 'xlsx':
      case 'xls':
        return <FaFileExcel className="file-icon excel" />;
      case 'docx':
      case 'doc':
        return <FaFileWord className="file-icon word" />;
      case 'pdf':
        return <FaFilePdf className="file-icon pdf" />;
      case 'csv':
        return <FaFileCsv className="file-icon csv" />;
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
        return <FaFileImage className="file-icon image" />;
      default:
        return <FaFile className="file-icon default" />;
    }
  };

  // 파일 다운로드 처리
  const handleDownload = async () => {
    try {
      // Flowise API 응답의 파일 URL 처리
      const response = await fetch(url);
      const blob = await response.blob();

      // 다운로드 링크 생성
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename || `download.${getFileExtension(url)}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 메모리 정리
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('파일 다운로드 오류:', error);
      // 직접 링크로 열기 시도
      window.open(url, '_blank');
    }
  };

  const ext = getFileExtension(url);
  const displayName = filename || `파일.${ext}`;

  return (
    <div className="file-download-card">
      <div className="file-info">
        {getFileIcon(ext)}
        <div className="file-details">
          <div className="file-name">{displayName}</div>
          <div className="file-type">{ext.toUpperCase()} 파일</div>
        </div>
      </div>
      <button className="download-btn" onClick={handleDownload} title="다운로드">
        <FaDownload />
        <span>다운로드</span>
      </button>
    </div>
  );
};

export default FileDownload;
